export default {
    tag_ACCRUED_BONUSES: "Бонустарды есептеу",
    tag_ADDRESS: "Пациенттің мекенжайы",
    tag_ADDRESS_PREDSTAVITEL: "Клиент өкілінің мекенжайы",
    tag_BIRTHDAY: "Пациенттің туған күні",
    tag_BIRTHDAY_PREDSTAVITEL: "Пациент өкілінің туған күні",
    tag_BRANCH_ADDRESS: "Филиалдың мекенжайы",
    tag_BRANCH_BIN: "Филиалдың БСН",
    tag_BRANCH_INN: "Филиалдың ЖСН",
    tag_BRANCH_KPP: "Филиалдың КПП",
    tag_BRANCH_LICENSE: "Филиалдың лицензиясы",
    tag_BRANCH_OGRN: "Филиалдың НМТН",
    tag_BRANCH_TITLE: "Филиалдың атауы",
    tag_CARD_CLIENT: "Клиент карточкасының нөмірі",
    tag_CLIENT: "Клиенттің ТАӘ",
    tag_CLIENT_BONUSES: "Клиенттің бонустары",
    tag_CLIENT_NAME: "Клиенттің аты",
    tag_CLIENT_NAME_MNAME: "Клиенттің аты-жөні",
    tag_CLINIC: "Клиниканың атауы",
    tag_COMPLEX_STATUS: "Емдеу жоспары кешенінің статусы",
    tag_COST_DISCOUNTED: "Жеңілдіктерді есепке ала отырып қызметтердің құны",
    tag_COST_ORIGINAL: "Жеңілдіктерді есеп алмастан, қызметтердің құны",
    tag_DATA: "Құжатты жасау күні",
    tag_DATA_VIZIT: "Келу күні",
    tag_DATE: "Таратылымдарды жасау күні",
    tag_DATE_FIRST_VIZIT: "Алғашқы келу күні",
    tag_DATE_LAST_VIZIT: "Соңғы келу күні",
    tag_DIAGNOZ: "Диагноз",
    tag_DIAGNOZ_PLAN: "Емдеу жоспарынан диагноз",
    tag_DOCTOR: "Т.А.Ә. – дәрігердің ТАӘ",
    tag_DOCTOR_PHONE: "Дәрігердің телефоны",
    tag_DOCUMENT_TYPE_PREDSTAVITEL: "Пациент өкілінің құжат түрі",
    tag_EMAIL_CLIENT: "Клиенттің электрондық поштасы",
    tag_FIO_CLIENT: "Клиенттің Т.А.Ә.",
    tag_FIO_DIRECTOR: "Директордың Т.А.Ә.",
    tag_IIN: "Пациенттің ЖСН",
    tag_INN: "Пациенттің ЖСН",
    tag_LEGAL_ADDRESS: "Клиниканың заңды мекенжайы",
    tag_LEGAL_COMPANY_NAME: "Клиниканың заңды мекенжайы",
    tag_LEGAL_NAME: "Заңды мекенжайы",
    tag_LID: "Лид сілтеме",
    tag_PASSPORT: "Пациент паспортының нөмірі",
    tag_PASSPORT_CODE: "Пациент паспорты бөлімшесінің нөмірі",
    tag_PASSPORT_CODE_PREDSTAVITEL: "клиент өкілінің паспортының бөлішмше нөмірі",
    tag_PASSPORT_DATE: "Пациент паспортының берілген күні",
    tag_PASSPORT_DATE_PREDSTAVITEL: "Пациент өкілінің паспортының берілген күні",
    tag_PASSPORT_ISSUED: "Пациенттің паспорты кіммен берілген",
    tag_PASSPORT_ISSUED_PREDSTAVITEL: "Пациент өкілінің паспорты кіммен берілген",
    tag_PASSPORT_PREDSTAVITEL: "Клиент өкілі паспортының нөмірі",
    tag_PASSPORT_SERIES: "Пациент паспортының сериясы",
    tag_PASSPORT_SERIES_PREDSTAVITEL: "Клиент өкілінің құжат сериясы",
    tag_PHONE: "Клиенттің телефоны",
    tag_PHONE_CLIENT: "Клиенттің телефоны",
    tag_PHONE_PREDSTAVITEL: "Клиент өкілінің телефоны",
    tag_PLAN_STATUS: "Емдеу жоспарының статусы",
    tag_PLAN_TITLE: "Емдеу жоспарының атауы",
    tag_PLAN_TYPE: "Емдеу жоспарының түрі",
    tag_PREDSTAVITEL_PACIENTA: "Клиент өкілінің Т.А.Ә.",
    tag_SNILS: "Пациенттің СНИЛС",
    tag_SNILS_PREDSTAVITEL: "Пациент өкілінің СНИЛС",
    tag_TASK: "Тапсырма мәтіні",
    tag_URL_ANKETA: "Пациент сауалнамасына сілтеме",
    tag_URL_VIZIT_CONFIRMATION: "Келуді растауға сілтеме",
    tag_URL_VIZIT_REVIEW: "Келу туралы пікірге сілтеме",
    tag_USLUGI: "Қызметтер",
    tag_USLUGI_CLASSIFICATOR: "Жіктеуіш коды бар қызметтер",
    tag_USLUGI_PLAN: "Емдеу жоспарынан қызметтер",
    tag_VISIT_DOCTOR: "Келу дәрігерінің Т.А.Ә.",
    tag_ZAKAZ_NARYAD: "Тапсырыс нөмірі мен күні",
    tag_ZUB: "Тіс(-тер)"
}
